/** Confirm dialog copy for clearing all cached Destiny Chronicle data. */
export const CLEAR_CACHED_DATA_CONFIRM_MESSAGE =
  'Are you sure you want to clear all cached data?\n\n' +
  'This will remove:\n' +
  '• All stored activity history\n' +
  '• All cached character data\n' +
  '• All favorite accounts\n' +
  '• All Guardian Firsts data\n' +
  '• All Titles data\n\n' +
  'You will need to re-download all data on your next visit.';
